import React from "react";
import { Avatar, Badge, Box, Stack, Tooltip, Typography } from "@mui/material";
import AllInboxOutlinedIcon from "@mui/icons-material/AllInboxOutlined";
import { PASTEL, getBrandColor } from "./livechatTheme";
import { getInitials } from "./livechatDisplayUtils";

// Rail kanal permanen (dulu popup "Semua Brands" di header) — 1 kolom vertikal di sebelah
// kiri ConversationList, tiap kanal jadi rect rounded dengan badge unread count sendiri.
export default function ChannelRail({ brands, activeBrand, onSelect, unreadByBrand }) {
    const items = [
        { key: "all", label: "Semua", color: PASTEL.primary, icon: null },
        ...brands.map((b) => ({ key: b.brand, label: b.brand, color: getBrandColor(b.brand), icon: b.brandIcon || null })),
    ];

    return (
        <Box
            sx={{
                width: 76,
                flexShrink: 0,
                borderRight: `1px solid ${PASTEL.border}`,
                backgroundColor: PASTEL.surfaceAlt,
                overflowY: "auto",
            }}
        >
            <Stack spacing={1} sx={{ p: 1 }}>
                {items.map((item) => {
                    const isActive = activeBrand === item.key;
                    const unread = unreadByBrand?.[item.key] || 0;

                    return (
                        <Tooltip key={item.key} title={item.label} placement="right">
                            <Badge
                                badgeContent={unread}
                                color="error"
                                max={99}
                                sx={{
                                    width: "100%",
                                    "& .MuiBadge-badge": { top: 8, right: 10, fontSize: 9, height: 16, minWidth: 16 },
                                }}
                            >
                                <Box
                                    component="button"
                                    type="button"
                                    onClick={() => onSelect(item.key)}
                                    sx={{
                                        width: "100%",
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        gap: 0.5,
                                        py: 1,
                                        px: 0.5,
                                        border: "none",
                                        borderRadius: 2,
                                        cursor: "pointer",
                                        fontFamily: "inherit",
                                        backgroundColor: isActive ? PASTEL.primarySoft : "transparent",
                                        "&:hover": { backgroundColor: PASTEL.primarySoft },
                                    }}
                                >
                                    {item.key === "all" ? (
                                        <AllInboxOutlinedIcon
                                            sx={{ fontSize: 20, color: isActive ? PASTEL.primary : "text.secondary" }}
                                        />
                                    ) : item.icon ? (
                                        <Avatar
                                            src={item.icon}
                                            sx={{
                                                width: 24, height: 24, flexShrink: 0,
                                                outline: isActive ? `2px solid ${item.color}55` : "none",
                                                outlineOffset: "2px",
                                            }}
                                        />
                                    ) : (
                                        <Avatar
                                            sx={{
                                                width: 24, height: 24, flexShrink: 0,
                                                fontSize: 10, fontWeight: 700, color: "#fff",
                                                backgroundColor: item.color,
                                                outline: isActive ? `2px solid ${item.color}55` : "none",
                                                outlineOffset: "2px",
                                            }}
                                        >
                                            {getInitials(item.label)}
                                        </Avatar>
                                    )}
                                    <Typography
                                        sx={{
                                            fontSize: 9.5,
                                            lineHeight: 1.15,
                                            fontWeight: isActive ? 700 : 500,
                                            color: isActive ? PASTEL.primary : "text.secondary",
                                            textAlign: "center",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            maxWidth: "100%",
                                        }}
                                    >
                                        {item.label}
                                    </Typography>
                                </Box>
                            </Badge>
                        </Tooltip>
                    );
                })}
            </Stack>
        </Box>
    );
}
